import { Prohibit } from "@phosphor-icons/react";
import { AREA_LABEL } from "@/lib/areas";

// Shown when a logged-in user does not have access to an operational area.
// This is a per-user permission block (set by an admin), not a PIN lock.
export default function AreaDenied({ area }) {
  const label = AREA_LABEL[area] || "this area";
  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid={`area-denied-${area}`}>
      <div className="w-full max-w-sm border border-border rounded-sm bg-card p-8 space-y-4 relative overflow-hidden text-center">
        <Prohibit size={140} weight="fill" className="absolute -right-8 -bottom-8 text-red-500/10" />
        <div className="relative">
          <div className="w-12 h-12 rounded-sm bg-red-500/15 border border-red-500/40 flex items-center justify-center text-red-400 mb-4 mx-auto"><Prohibit size={26} weight="fill" /></div>
          <p className="uppercase text-xs tracking-[0.2em] font-bold text-red-400">Access not granted</p>
          <h1 className="font-display font-black uppercase tracking-tighter text-3xl mt-1">{label}</h1>
          <p className="text-sm text-muted-foreground mt-3">Non hai l'accesso a questa sezione. Chiedi a un amministratore di abilitarla per il tuo account.</p>
        </div>
      </div>
    </div>
  );
}
